<template>
  <section class="section container pt-0">
    <messages-datatable />
    <webhook-datatable class="mt-5" />
  </section>
</template>

<script>
import MessagesDatatable from "./messages_datatable/Index.vue";
import WebhookDatatable from "./webhook_datatable/Index.vue";

export default {
  name: "WhatsappIndex",
  components: {
    MessagesDatatable,
    WebhookDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
